module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/universes/beauty-6d7451445d89bc5d0b6bf74797abffc1.png";